interface DraftBannerProps {
  savedAt: Date
  onResume: () => void
  onDiscard: () => void
}

/** Offers to reopen the menu that was being edited before the page was closed */
export const DraftBanner = ({ savedAt, onResume, onDiscard }: DraftBannerProps) => (
  <div className="mb-4 rounded-lg bg-white/95 p-4 shadow-sm">
    <p className="text-sm font-medium text-custom-dark">You have a menu in progress</p>
    <p className="text-xs text-gray-500 mb-3">
      Last saved {savedAt.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}
    </p>
    <div className="flex gap-2">
      <button
        onClick={onResume}
        className="px-4 py-2 text-sm font-medium text-white rounded-md hover:opacity-80 bg-brand-primary"
      >
        Continue editing
      </button>
      <button
        onClick={onDiscard}
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
      >
        Discard
      </button>
    </div>
  </div>
)
